/* eslint-disable indent,prefer-template,no-unused-vars,padded-blocks,spaced-comment,dot-notation,object-curly-spacing */
import _ from 'lodash';

const merchantServicesServiceFactory = function ($log, $q, $http, Environment, StorageService, NewBackendService, endPoints) {
  'ngInject';
  const that = this;
  that.tenantId = '';
  that.accessCode = '';

  const parsers = {
    app: {},
    be: {
      getStoreSetupParser: response => ({
        data: response.element, //???
      }),
      getStoreConfigParser: response => ({
        data: response.element, //???
      })
    }
  };

  const httpPut = (servicePath, dataRequest, extraOptions) => $q((resolve, reject) => {
    const url = Environment.endPoints.webApiUrl + servicePath;
    $http.put(url, dataRequest, extraOptions)
      .success((data, status, headers, config) => {
        $log.debug(data);
        resolve(data);
      })
      .error((data, status, headers, config) => { // eslint-disable-line no-unused-vars
        reject(data);
      });
  });
  const httpGet = (servicePath, extraOptions) => $q((resolve, reject) => {
    const url = Environment.endPoints.webApiUrl + servicePath;
    $http.get(url, extraOptions)
      .success((data, status, headers, config) => {
        $log.debug(data);
        resolve(data);
      })
      .error((data, status, headers, config) => { // eslint-disable-line no-unused-vars
        reject(data);
      });
  });

  //UTILS


  const getCookie = (cname) => {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  };

  const getConfigWithAccessToken = () => {
    const config = { headers: {} };
    config.headers = {};
    const cookie = getCookie('access_token');
    //if (cookie.trim() !== '') {
      //config.headers['Authorization'] = 'Bearer ' + getCookie('access_token');
      config.headers['Authorization'] = 'Bearer ' + StorageService.getLocalStorage('access_token');
    //}
    config.customErrorManagement = true;
    return config;
  };

  const __searchForMerchantWithAliasContain__ = (page, elementsPerPage, string) => $q(
    (resolve, reject) => {

      const accessTokenConfig = getConfigWithAccessToken();
      $http.get('/ApiProxy/merchants/search?alias=' + string + '&page=' + page + '&size=' + elementsPerPage, accessTokenConfig).then(resolve, reject);

    }
  );

  const ensableQueryString = (queryParams) => {

    let queryString = '?';
    let queryStringParts = [];
    for (let filterName in queryParams) {
      const prop = queryParams[filterName];
      if (prop === undefined || prop === null || prop.trim() === '') {
        continue;
      }
      queryStringParts.push(filterName + '=' + prop);
    }
    queryString += queryStringParts.join('&');
    return queryString;
  };

  //UTILS

  const service = {
    setTenantId: (tenantId) => {
      that.tenantId = tenantId;
    },
    setAccessCode: (accessCode) => {
      that.accessCode = accessCode;
    },

    getMerchants: (page, size, alias, vasTypeIds, type) => $q(
      (resolve, reject) => {

        const extraOptions = {
            page,
            size,
            vasTypeIds,
            alias,
            type: type
          }

        //_.merge(extraOptions, getConfigWithAccessToken());

        NewBackendService.invokeWebApiGet(`${endPoints.ecommerceUrl}/businesses/search`, extraOptions).then(resolve, reject);
      }
    ),
    getStoreSetup: (storeId) => $q((resolve, reject) => {
      httpGet('oxl/tinaba/setup/' + that.tenantId + '/store/' + storeId).then(resultData => {
        if (resultData.status === 204) {
          resolve([]);
        } else {
          resolve(_.map(resultData.data.response, parsers.be.getStoreSetupParser));
        }
      }, reject);
    }),
    setStoreSetup: (storeId, setupObj) => $q((resolve, reject) => {
      const data = {
        access_token: '', store: storeId, setup: setupObj
      };

      httpPut('oxl/tinaba/setup/' + that.tenantId + '/store/', data).then(resultData => {
        if (resultData.status === 204) {
          resolve([]);
        } else {
          resolve(_.map(resultData.data.response, parsers.be.getStoreSetupParser));
        }
      }, reject);
    }),
    getStoreConfig: (storeId) => $q((resolve, reject) => {
      httpGet('oxl/tinaba/' + that.tenantId + '/config/' + storeId).then(resultData => {
        if (resultData.status === 204) {
          resolve([]);
        } else {
          resolve(_.map(resultData.data.response, parsers.be.getStoreConfigParser));
        }
      }, reject);
    }),
    setStoreConfig: (storeId, setupObj) => $q((resolve, reject) => {
      const data = {
        access_token: '', store: storeId, setup: setupObj
      };

      httpPut('oxl/tinaba/' + that.tenantId + '/config/', data).then(resultData => {
        if (resultData.status === 204) {
          resolve([]);
        } else {
          resolve(_.map(resultData.data.response, parsers.be.getStoreConfigParser));
        }
      }, reject);
    }),

  };

  return service;
};


export default merchantServicesServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/merchant.services.factory.js
 **/